<template lang="pug">
  footer.footer(v-lazyload)
    .container
      .footer__content
        .footer__copyright
          span © {{ year }},
          span «{{ copyrightText }}»
        HeaderSocials
        .footer__address
          span {{ addressUpperText }}
          span {{ addressLowerText }}
</template>

<script>
import HeaderSocials from '@/components/header/HeaderSocials'
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  components: {
    HeaderSocials
  },
  data: () => ({
    year: new Date().getFullYear()
  }),
  computed: {
    ...mapState('siteVersions', {
      isTurkey: state => state.item?.code === 'tr'
    }),
    copyrightText: vm => vm.isTurkey
      ? 'Gorilla Beverages Holding Company Ltd.'
      : 'Gorilla Drinks Limited',
    addressUpperText: vm => vm.isTurkey
      ? 'Address: Unit 05, Level 3'
      : 'Arch.Makariou III, 212 SETA COURT',
    addressLowerText: vm => vm.isTurkey
      ? 'GV04, DIFC, Dubai, UAE'
      : 'flatloffice 12/1, 3030, Limassol, Cyprus'
  }
}
</script>
